import MojitoModules from 'mojito/modules';

import {isMobile} from '#core/utils/context-utils.js';

const {types: SportGroupsListTypes} = MojitoModules.SportGroupsList;

import {PALETTE_IDS} from '#core/application/modules/ids.js';

import {COLOR, FONT} from '../theme.js';

const isSportiumEs = CLIENT_NAME === 'sportium-es';

const CUSTOM_CONFIG = {
    [PALETTE_IDS.COUPONS]: {
        // DBX-12584
        CmsSportCouponView: {
            eventCoupon: {
                eventList: {
                    eventItem: {
                        genericMarketContent: {
                            layoutDescriptors: {
                                types: isSportiumEs
                                    ? {
                                          PLSP: {
                                              selectionNameDisplay: 'hide',
                                          },
                                          TMSP: {
                                              selectionNameDisplay: 'hide',
                                          },
                                      }
                                    : {},
                            },
                        },
                    },
                },
            },
        },
        SportGroupsListView: {
            defaultSortingMethod: SportGroupsListTypes.SORTING_TYPES.BY_DISPLAY_ORDER,
        },
    },
    [PALETTE_IDS.SPORTS_CONTENT]: {
        // DBX-13120, DBX-14918
        EventsCoupon: {
            eventList: {
                eventItem: {
                    marketsSectionContainer: {
                        sportWidthOverride: {
                            _mobile_american_football: '194px',
                            _mobile_baseball: '194px',
                            _mobile_basketball: '220px',
                            _mobile_ice_hockey: '194px',
                            american_football: '62%',
                            baseball: '62%',
                            basketball: '62%',
                            ice_hockey: '62%',
                        },
                    },
                },
                eventListGroup: {
                    headerSegmentsContainer: {
                        sportWidthOverride: {
                            _mobile_american_football: '194px',
                            _mobile_baseball: '194px',
                            _mobile_basketball: '220px',
                            _mobile_ice_hockey: '194px',
                            american_football: '62%',
                            baseball: '62%',
                            basketball: '62%',
                            ice_hockey: '62%',
                        },
                    },
                },
            },
        },
    },
};

export function getSportsContentConfigs() {
    return {
        custom: CUSTOM_CONFIG,
        palette: {
            [PALETTE_IDS.EVENT_LIST]: {
                EVENT_LIST_HEADER: {
                    EVENT_LIST_HEADER_WITH_SEPARATOR: false,
                    EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                    EVENT_LIST_HEADER_TEXT: {
                        color: COLOR.BRAND.FOREGROUND4,
                        textTransform: 'uppercase',
                    },
                    EVENT_LIST_HEADER_SORT_TEXT: COLOR.BRAND.FOREGROUND4,
                    EVENT_LIST_HEADER_MARKETS_TEXT: COLOR.BRAND.FOREGROUND4,
                },
                EVENT_LIST_MOBILE_HEADER: {
                    EVENT_LIST_HEADER_WITH_SEPARATOR: false,
                    EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                    EVENT_LIST_HEADER_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        textTransform: 'uppercase',
                    },
                    EVENT_LIST_HEADER_SORT_TEXT: COLOR.BRAND.FOREGROUND1,
                    EVENT_LIST_HEADER_MARKETS_TEXT: COLOR.BRAND.FOREGROUND1,
                },

                EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND2,
                EVENT_LIST_GROUP_NAME_TEXT: {
                    color: COLOR.BRAND.FOREGROUND1,
                    fontWeight: FONT.WEIGHT_BOLD,
                },
                EVENT_LIST_GROUP_MARKET_TEXT: COLOR.BRAND.FOREGROUND2,
            },
            [PALETTE_IDS.PROMOTION_QUICK_LINKS]: {
                PROMOTION_QUICK_LINK_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND4,
                },
            },
            [PALETTE_IDS.SPORTS_CONTENT]: {
                SPORT_TABS_PIVOT: {
                    PIVOT_ROW_BG: COLOR.BRAND.BACKGROUND5,
                },
                GOAL_LABEL_BG: COLOR.BRAND.ACCENT2,
                GOAL_LABEL_TEXT: COLOR.BRAND.BACKGROUND1,
            },
            [PALETTE_IDS.SPORT_PAGE]: {
                SPORT_HEADER_TEXT: COLOR.BRAND.FOREGROUND5,

                LEAGUES_SECTION_HEADER_TEXT: COLOR.BRAND.FOREGROUND3,

                EVENT_LIST_SKELETON: {
                    EVENT_LIST_HEADER: {
                        EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                    },
                    EVENT_LIST_MOBILE_HEADER: {
                        EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND1,
                    },
                    EVENT_LIST_GROUP_HEADER_BG: COLOR.BRAND.BACKGROUND2,
                },
                EVENT_LIST_GROUP_HEADER_ITEM_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND3,
                },

                SPORT_HEADER_BG: COLOR.BRAND.BACKGROUND5,
            },
            [PALETTE_IDS.COUPONS]: {
                TOP_SPORTS_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND3,
                },

                IN_PLAY_COUPON: {
                    EVENTS_COUPON_EVENT_LIST: {
                        EVENT_LIST_MOBILE_HEADER: {
                            EVENT_LIST_HEADER_BG: COLOR.BRAND.BACKGROUND5,
                            EVENT_LIST_HEADER_MARKETS_TEXT: COLOR.BRAND.FOREGROUND4,
                        },
                    },
                },

                PRICE_BOOST_COUPON_EVENT_SEPARATOR_COLOR: 'transparent',
                PRICE_BOOST_COUPON_ITEM: {
                    PBI_SELECTION_NAME_TEXT: {
                        color: COLOR.BRAND.FOREGROUND1,
                        fontWeight: FONT.WEIGHT_BOLD,
                    },
                },
                SINGLE_LEAGUE_COUPON: {
                    EVENTS_COUPON_EVENT_LIST: {
                        EVENT_LIST_GROUP_OFFERS_LABEL_TEXT: isMobile()
                            ? COLOR.BRAND.FOREGROUND2
                            : COLOR.BRAND.FOREGROUND5,
                    },
                },
            },
            [PALETTE_IDS.HOME_PAGE]: {
                HOME_PAGE_TOP_SPORTS_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,
                HOME_PAGE_TOP_SPORTS_SKELETON_PART: {
                    SKELETON_COLOR: COLOR.BRAND.FOREGROUND3,
                },
            },
            [PALETTE_IDS.INPLAY_PAGE]: {
                INPLAY_SPORTS_SELECTOR: {
                    TOGGLE_BUTTON_BG: COLOR.BRAND.BACKGROUND1,
                },
            },
            [PALETTE_IDS.EVENT_PAGE]: {
                EVENT_PAGE_VISUALISATION_CONTAINER_BG: COLOR.BRAND.BACKGROUND5,
            },
        },
    };
}
